import React from "react";
import Challenge from "./Challenge";
import { times } from "lodash";

const hintRowCount = 60;
const hintColumnCount = 150;

const hintRotations = times(hintRowCount, row =>
  times(hintColumnCount, column => Math.floor(Math.random() * 360))
);

export default props => (
  <Challenge
    rowCount={hintRowCount}
    columnCount={hintColumnCount}
    acceptedRune="arrow"
    hintElement="/\"
    titleText="going up"
    useSingleHints={true}
    makeElementStyles={(i, j) => ({
      transform: `rotateZ(${hintRotations[i][j]}deg)`
    })}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/challenges/ArrowChallenge.js